
export default function ChromebookRepair() {
  const repairs = [
    {
      icon: 'ri-keyboard-line',
      title: 'Keyboard Replacement',
      description: 'Replace damaged or non-responsive keys with genuine parts for smooth typing experience.',
      price: 'From $89'
    },
    {
      icon: 'ri-computer-line',
      title: 'Screen Repair',
      description: 'Fix cracked or damaged displays with high-quality replacement screens.',
      price: 'From $59'
    },
    {
      icon: 'ri-battery-charge-line',
      title: 'Battery Service',
      description: 'Replace worn-out batteries to restore your Chromebook\'s portability and runtime.',
      price: 'From $69'
    },
    {
      icon: 'ri-settings-3-line',
      title: 'System Optimization',
      description: 'Speed up your Chromebook with software updates and performance tuning.',
      price: 'From $49'
    }
  ];

  return (
    <section id="chromebook-repair" className="py-16 sm:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-10 sm:mb-16">
          <div className="inline-block px-4 py-1.5 border border-teal-600 text-teal-600 text-xs font-semibold rounded-full mb-4">
            CHROMEBOOK SERVICES
          </div>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Expert Chromebook <br className="hidden sm:block" />Repair &amp; Support
          </h2>
          <p className="text-base sm:text-lg text-gray-600 max-w-2xl mx-auto">
            Specialized repair services for all Chromebook models. Fast turnaround times and quality parts guaranteed
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
          {repairs.map((repair, index) => (
            <div
              key={index}
              className="bg-gray-50 p-6 rounded-xl hover:shadow-lg transition-all duration-300 cursor-pointer border border-transparent hover:border-teal-600"
            >
              <div className="w-12 h-12 flex items-center justify-center bg-white rounded-lg mb-4">
                <i className={`${repair.icon} text-2xl text-teal-600`}></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">{repair.title}</h3>
              <p className="text-sm text-gray-600 mb-4 leading-relaxed">{repair.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
